import { Box, Typography, useMediaQuery } from "@mui/material";
import { useParams } from "react-router-dom";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { useAppSelector } from "../../../store/hooks";
export var AccountPostingMobile = function () {
    var crud = useAppSelector(function (state) { return state.crud; });
    var _a = useAppSelector(function (state) { return state.crud; });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var id = useParams().id;
    var AccountPostingArray = [{
            id: '01',
            ProductName: '*Purchase*',
            SKUCode: '*BM9090*',
            DebitAmount: '*00.00*',
            CreditAmount: '*00.00*'
        }, {
            id: '02',
            ProductName: '*Purchase*',
            SKUCode: '*BM9090*',
            DebitAmount: '*00.00*',
            CreditAmount: '*00.00*'
        }];
    var partElements = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: '0px',
            rowSpacing: 2,
            columnSpacing: 2,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'DebitAmount',
                    label: 'Debit amount :',
                    columnSize: 12,
                    disabled: true
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'CreditAmount',
                    label: 'Credit amount :',
                    columnSize: 12,
                    disabled: true
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'Remark',
                    label: 'Remark :',
                    columnSize: 12,
                    multiline: true,
                    minRows: 3
                }]
        }];
    var detailsTab = [{
            type: FormItemTypes.List,
            name: 'AcountPosting',
            columnSize: 12,
            variant: 'comfortable',
            value: AccountPostingArray,
            disableCheckboxSelection: true,
            columns: [{
                    field: 'AcountPosting',
                    flex: 1,
                    renderCell: function (params) {
                        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                            variant: "h3"
                        }, params.row.ProductName), /*#__PURE__*/ React.createElement(Typography, {
                            variant: "h6",
                            color: "secondary"
                        }, params.row.SKUCode ? '#' + params.row.SKUCode : ''));
                    }
                }],
            elements: partElements
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            paddingBottom: 7,
            bgcolor: ''
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: detailsTab
    })));
};
